import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  console.log('locale: ', locale);
  const { esUS } = ABCyaLib.Environment.LOCALES;

  const config = {
    // add your game config options here, these can be the default values
    menuPopupFontSize: 20,
  };

  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  };

  switch (locale) {
    case esUS:
      config.menuPopupFontSize = 14;
      break;
  }

  return config;
}